import type { ReactElement } from "react";
import { useState } from "react";

import { IconButton, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import {
    StyledAddConditionContainer,
    StyledEmptyText,
} from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IIndustryCodesFilterDto } from "app/pages/sales-intelligence/domain/industry/types/filter-values";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type IndustryCodesFilterModel from "../../../models/IndustryCodesFilter/IndustryCodesFilterModel";
import { IndustryCodesModal } from "./modals/IndustryCodesModal/IndustryCodesModal";

const IndustryCodesFilter = ({
    value = [],
    filter,
    onFilterUpdate,
}: IFilterViewBaseProps<IndustryCodesFilterModel>): ReactElement => {
    const [isOpenModal, setIsOpenModal] = useState(false);
    const { codeOptions, options } = filter;
    const { naicsCode: naicsCodes, sicCodes } = options;

    const handleOpenModal = () => {
        setIsOpenModal(true);
    };

    const renderAddButton = () => {
        const button = (
            <IconButton
                type="flat"
                iconName="add"
                onClick={handleOpenModal}
                dataAutomation="industry-codes-filter-button-add"
            >
                {translate("si.lead_gen_filters.filters.industryCodes.button.add")}
            </IconButton>
        );

        if (value.length > 0) {
            return (
                <Tooltip content={translate("si.lead_gen_filters.filters.industryCodes.button.add.tooltip")}>
                    {button}
                </Tooltip>
            );
        }

        return button;
    };

    const handleClose = () => {
        setIsOpenModal(false);
    };

    const handleApply = (item: IIndustryCodesFilterDto) => {
        onFilterUpdate([...value, item]);
        setIsOpenModal(false);
    };

    return (
        <>
            <IndustryCodesModal
                isOpen={isOpenModal}
                selected={null}
                value={value}
                codeOptions={codeOptions}
                naicsCodes={naicsCodes}
                sicCodes={sicCodes}
                isExcludeAvailable={filter.isExcludeInclusionAvailable(value, null)}
                onClose={handleClose}
                onCancel={handleClose}
                onApply={handleApply}
            />

            <StyledEmptyText isHidden={value.length > 0}>
                {translate("si.lead_gen_filters.filters.industryCodes.empty_text")}
            </StyledEmptyText>
            <StyledAddConditionContainer>{renderAddButton()}</StyledAddConditionContainer>
        </>
    );
};

export default IndustryCodesFilter;
